import navLogo from '@/assets/img/logo/logo.png'
import headPortrait from '@/assets/img/avatarImg.png'

export default {
	state: {
		componentKey: 0,
		userName: localStorage.userName,
		userId: '',
		isLogining: false, //用户是否登录  false 已登录   true 未登录
		avatarImgPath: headPortrait,
		navLogo: navLogo,
		footerLogo: navLogo,
		subjectColor: { //选中的主题色
			mainColor: '#1459F4',
			complementaryColors: '#004de1',
		},
		generalSetting: {
			themeColor: [{
				mainColor: '#1459F4',
				complementaryColors: '#004de1',
				checked: true
			}, {
				mainColor: '#00bfbf',
				complementaryColors: '#00abab',
				checked: false
			}, {
				mainColor: '#f59a23',
				complementaryColors: '#e38100',
				checked: false
			}, {
				mainColor: '#d9001b',
				complementaryColors: '#cc0019',
				checked: false
			}],
			webLogo: '', //前台LOGO
			footerLogo: '', //前台页脚logo
			footerQRCode: [],
			serviceTel: '',
			wechatNumber: '',
			address: '',
			copyright: '', //版权信息
			archivalInfo: '', //备案信息
			businessCertificate: '', //增值电信业务经营许可证
			beijingPublicNetworkSecurity: '', //京公网安备
		},
		channel: '',
		reportId: '',


	},
	mutations: {
		changeChannel(state, data) {
			state.channel = data;
		},
		setUserName(state, name) {
			state.userName = name
		},
		setAvatar(state, avatarPath) {
			state.avatarImgPath = avatarPath
		},
		setIsLogining(state, isLogining) {
			state.isLogining = isLogining
		},
		setGeneralSetting(state, generalSetting) {
			state.generalSetting = generalSetting
		},
		setComponentKey(state, key) {
			state.componentKey = key
		}


	},
	getters: {

	},
	actions: {
		getUserInfo({
			state,
			commit
		}, {
			data
		}) {
			return new Promise((resolve, reject) => {
				try {
					commit('setUserName', data.name)

				} catch (error) {
					reject(error)
				}
			})
		},
		getIsLogining({
			commit
		}, {
			isLogining
		}) {
			commit('setIsLogining', isLogining)
		},
		getsAvatar({
			state,
			commit
		}, {
			headPortrait
		}) {
			return new Promise((resolve, reject) => {
				try {
					commit('setAvatar', headPortrait)
				} catch (error) {
					reject(error)
				}
			})
		},
		getGeneralSetting({
			commit
		}, {
			generalSetting
		}) {
			return new Promise((resolve, reject) => {
				try {
					// console.log('执行通用设置', generalSetting)
					commit('setGeneralSetting', generalSetting)
				} catch (error) {
					reject(error)
				}
			})
		},
		updateComponentKey({
			commit
		}, {
			key
		}) {
			return new Promise((resolve, reject) => {
				try {
					commit('setComponentKey', key)
				} catch (error) {
					reject(error)
				}
			})
		},



	}
}